import { motion } from "framer-motion";

import React, { ComponentType, useState } from "react";
import styled from "styled-components";

const ScrollX = styled.div`
  width: 100%;

  position: relative;
  display: flex;
  z-index: 0;
  flex-direction: row;
  align-items: center;
  justify-content: space-around;
  overflow: hidden;
  .scroll-inner {
    display: flex;

    flex-direction: row;
    width: min-content;
    z-index: 500;
    & > * {
      margin-left: 10px;
      margin-right: 10px;
    }
    -ms-overflow-style: none;
    scrollbar-width: none;
  }
  .scroll-inner::-webkit-scrollbar {
    display: none;
  }
`;

const swipeConfidenceThreshold = 100;
const swipePower = (offset: number, velocity: number) => {
  return Math.abs(offset) * velocity;
};

const wrap = (min: number, max: number, v: number) => {
  const rangeSize = max - min;
  return ((((v - min) % rangeSize) + rangeSize) % rangeSize) + min;
};

type ScrollerProps = {
  visibleCards?: number;
  ArrowLeft?: ComponentType<{onClick: VoidFunction}>;
  ArrowRight?: ComponentType<{onClick: VoidFunction}>;
};

export const Scroller: React.FC<ScrollerProps> = ({
  children,
  visibleCards = 3,
  ArrowLeft,
  ArrowRight,
}) => {
  const [offset, setOffset] = useState(0);
  const [dragging, setDragging] = useState(false)
  const scrollLeft = () => setOffset((v) => v + 1);
  const scrollRight = () => setOffset((v) => v - 1);
  const childrenArray = React.Children.toArray(children);

  return (
    <ScrollX>
      {ArrowLeft && <ArrowLeft onClick={() => scrollLeft()}/>}
      <div className="scroll-inner">
        {childrenArray.map((_, i) => {
          const index = i + offset;

          const isInvisible = i == 0 || i == visibleCards + 1;
          const isHidden = i > visibleCards + 1;
          const leftMost = i == 0;
          const rightMost = i >= visibleCards + 1;

          if(isHidden){
            return null
          }

          return (
            <motion.div
              key={index}
              data-index={wrap(0, childrenArray.length, index)}
              layout={"position"}
              initial={false}
              animate={{ opacity: isInvisible ? 0 : 1 }}
              style={{
                position: isInvisible ? "absolute" : "relative",
                zIndex: isInvisible ? -1 : 1,
                left: leftMost ? "-100%" : "",
                right: rightMost ? "-100%" : "",
                pointerEvents: (isInvisible || dragging) ? 'none' : 'auto'
              }}
              drag="x"
              dragConstraints={{ left: 50, right: 50 }}
              dragElastic={0.5}
              onDragStart={() => {
                setDragging(true)
              }}
              onDragEnd={(e, { offset, velocity }) => {
                setDragging(false)
                const swipe = swipePower(offset.x, velocity.x);

                if (swipe < -swipeConfidenceThreshold) {
                  scrollLeft();
                } else if (swipe > swipeConfidenceThreshold) {
                  scrollRight();
                }
              }}
            >
              {childrenArray[wrap(0, childrenArray.length, index)]}
            </motion.div>
          );
        })}
      </div>

      {ArrowRight && <ArrowRight onClick={() => scrollRight()} />}
    </ScrollX>
  );
};
